export default __webpack_public_path__ + "static/media/6_Intro.846d1168.mp4";